import { createContext } from "react";
import type { SetTableSortContextType } from "../TableSortProvider.types";

const SetTableSortContext = createContext<SetTableSortContextType | undefined>(undefined);
SetTableSortContext.displayName = "SetTableSortContext";

export default SetTableSortContext;
